// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"834e7b6b","257":"853aef36"}[chunkId] + ".chunk.css";
};